












import { ErrorCode, ErrorSeverity, ThrowErrorFunction, isDownstreamErrorCode } from "~/modules/error";
import { HttpAdapter } from "~/backend/HttpAdapter/HttpAdapter";
import { AuthenticationMethod } from "~/backend/commons/authenticationMethods";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";
import { SimpleHttpAdapterImpl } from "~/backend/SimpleHttpAdapter/SimpleHttpAdapterImpl";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { stringifyParams } from "~/utils/stringifyParams";

import { ChannelNote } from "../model/channelNote";
import { TwilioServiceErrorResponse } from "../model/twilioServiceErrorResponse";
import { UpdateChannelNoteRequest } from "../model/updateChannelNoteRequest";

import { ChannelNoteService }  from "./channelNote.serviceInterface";

export class ChannelNoteServiceImpl implements ChannelNoteService {
    private simpleHttpAdapter: HttpAdapter;

    readonly #throwError: ThrowErrorFunction;

    constructor(ctx: ContextManager) {
        this.simpleHttpAdapter = new SimpleHttpAdapterImpl(ctx);
        this.#throwError = throwFlexSdkError(ctx);
        this.simpleHttpAdapter.setIsEdgeSupported();

    }

    






    public async getChannelNote(instanceSid: string, noteSid: string): Promise<ChannelNote> {
        const metadata = {
            module: "backend",
            severity: ErrorSeverity.Error,
            source: "channelNote.service.ts"
        };
        if (instanceSid === null || instanceSid === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter instanceSid was null or undefined.");
        }
        if (noteSid === null || noteSid === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter noteSid was null or undefined.");
        }

        let response;
        try {
            response = await this.simpleHttpAdapter.get<ChannelNote>(`https://preview[region].twilio.com/Flex/Instances/${encodeURIComponent(String(instanceSid))}/Notes/${encodeURIComponent(String(noteSid))}`, undefined);
        } catch (e) {
            if (isDownstreamErrorCode(e.code)) {
                const message = `ChannelNoteService - ${e.message}`
                return this.#throwError(ErrorCode.DownstreamServiceError, metadata, message) as unknown as Promise<never>;;
            }

            return Promise.reject(e)
        }
        return response;
    }

    








    public async updateChannelNote(instanceSid: string, noteSid: string, ifMatch: string, updateChannelNoteRequest: UpdateChannelNoteRequest): Promise<ChannelNote> {
        const metadata = {
            module: "backend",
            severity: ErrorSeverity.Error,
            source: "channelNote.service.ts"
        };
        if (instanceSid === null || instanceSid === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter instanceSid was null or undefined.");
        }
        if (noteSid === null || noteSid === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter noteSid was null or undefined.");
        }
        if (ifMatch === null || ifMatch === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter ifMatch was null or undefined.");
        }
        if (updateChannelNoteRequest === null || updateChannelNoteRequest === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter updateChannelNoteRequest was null or undefined.");
        }

        let response;
        try {
            response = await this.simpleHttpAdapter.post<ChannelNote>(`https://preview[region].twilio.com/Flex/Instances/${encodeURIComponent(String(instanceSid))}/Notes/${encodeURIComponent(String(noteSid))}`, undefined, updateChannelNoteRequest);
        } catch (e) {
            if (isDownstreamErrorCode(e.code)) {
                const message = `ChannelNoteService - ${e.message}`
                return this.#throwError(ErrorCode.DownstreamServiceError, metadata, message) as unknown as Promise<never>;;
            }

            return Promise.reject(e)
        }
        return response;
    }
}

